import React, { Component, Fragments } from "react";
import { Redirect, Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { AgentService } from './_service.agent';
import { ToastSuccess } from '../../Services/_toast.service';

class AgentEdit extends Component {
	state = {
		editAgent: [],
		loading: false,
		errors: null
	};

	componentWillReceiveProps(nextProps) {
		if (this.props.singleAgent !== nextProps.singleAgent) {
			this.setState({ editAgent: nextProps.singleAgent });
		}
	}

	// handle inputs
	handleInputChange = e => {
		this.setState({
			editAgent: {
				...this.state.editAgent,
				[e.target.name]: e.target.value
			}
		});
	};

	// on submit
	onFormSubmit = e => {
		e.preventDefault();
		let agent = this.state.editAgent;
					
		let update = {
			name: agent.name,
			business_name: agent.business_name,
			address: agent.address,
			landline: agent.landline,
			fax: agent.fax,
			email: agent.email,
			mobile: agent.mobile,
			contact_person: agent.contact_person,
			rate: agent.rate
		};

		this.updateSingleAgent(update, agent._id);
	};

	// update single agent
	updateSingleAgent = async (agent, id) => {
		this.setState({ loading: true });

		
		AgentService.updateSingleAgent(agent, id).then(res => {
			switch (res.data.status) {
					case 0:
						this.setState({ errors: res.data.errors });
						break;
					case 1:
						this.setState({
							editAgent: [],
							loading: false,
							errors: null
						});
						// hide the modal
						this.props.onHide();
						// load the data
						this.props.getAgents();
						// alert message
						ToastSuccess(res.data.message);
						break;
					default:
						break;
				}

			this.setState({ loading: false });

		}).catch(error => {
             alert(`An Error Occured! ${error}`);
             console.log(error);
        });    
	};

	render() {

		const {
			name,
			business_name,
			address,
			landline,
			fax,
			email,
			mobile,
			contact_person,
			rate,
		} = this.state.editAgent;

		return (
			<Modal
				className="modal-container"
				show={this.props.show}
				onHide={this.props.onHide}
				animation={true}
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>Edit Agent</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					{this.state.loading ? (
						<div>
							<h3 align="center" className="my-5">
								Loading Please wait...
							</h3>
						</div>
					) : (
						<div>
							<div>
								{this.state.errors && (
									<div
										className="alert alert-danger alert-dismissible fade show f-regular"
										role="alert"
									>
										{this.state.errors.map((error, i) => (
											<li key={i}>{error}</li>
										))}
										<button
											type="button"
											class="close"
											data-dismiss="alert"
											aria-label="Close"
										>
											<span aria-hidden="true">
												&times;
											</span>
										</button>
									</div>
								)}
							</div>

							<form onSubmit={e => this.onFormSubmit(e)}>
								<section className="row">
									<div className="col-sm-12">
										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Name:
											</label>
											<div className="col-md-8">
												<input
													type="text"
													id="name"
													name="name"
													className="form-control"
													placeholder="Name"
													value={name || ""}
													onChange={
														this.handleInputChange
													}
												/>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Business Name
											</label>
											<div className="col-md-8">
												<input
													type="text"
													id="business_name"
													name="business_name"
													className="form-control"
													placeholder="Business Name"
													value={business_name || ""}
													onChange={
														this.handleInputChange
													}
												/>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Address
											</label>
											<div className="col-md-8">
												<textarea
													id="address"
													name="address"
													rows="2"
													className="form-control"
													placeholder="Address"
													value={address || ""}
													onChange={
														this.handleInputChange
													}
												></textarea>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Landline
											</label>
											<div className="col-md-8">
												<input
													type="text"
													id="landline"
													name="landline"
													className="form-control"
													placeholder="Landline"
													value={landline || ""}
													onChange={
														this.handleInputChange
													}
												/>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Fax
											</label>
											<div className="col-md-8">
												<input
													type="text"
													id="fax"
													name="fax"
													className="form-control"
													placeholder="Fax"
													value={fax || ""}
													onChange={
														this.handleInputChange
													}
												/>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Email
											</label>
											<div className="col-md-8">
												<input
													type="email"
													id="email"
													name="email"
													className="form-control"
													placeholder="Email"
													value={email || ""}
													onChange={
														this.handleInputChange
													}
												/>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Mobile
											</label>
											<div className="col-md-8">
												<input
													type="text"
													id="mobile"
													name="mobile"
													placeholder="Mobile"
													className="form-control"
													value={mobile || ""}
													onChange={
														this.handleInputChange
													}
												/>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Contact Person
											</label>
											<div className="col-md-8">
												<input
													type="text"
													id="contact_person"
													name="contact_person"
													placeholder="Contact Person"
													className="form-control"
													value={contact_person || ""}
													onChange={
														this.handleInputChange
													}
												/>
											</div>
										</div>


										<div className="form-group row">
											<label className="col-md-4 label-control f-regular">
												Rate
											</label>
											<div className="col-md-8">
												<input
													type="text"
													id="rate"
													name="rate"
													placeholder="Rate"
													className="form-control"
													value={rate || ""}
													onChange={
														this.handleInputChange
													}
												/>
											</div>
										</div>

									</div>
								</section>

								<div className="row justify-content-end">
									<div className="mr-2">
										<div className="form-group f-regular">
											<Button
												type="button"
												className="btn btn-sm btn-danger"
												onClick={this.props.onHide}
											>
												Cancel
											</Button>{" "}
											<button
												type="submit"
												className="btn btn-primary btn-sm"
											>
												Save
											</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					)}
				</Modal.Body>
			</Modal>
		);
	}
}

export default AgentEdit;
